import { render } from "./HomePersonalProjects.vue?vue&type=template&id=1f2aa805&scoped=true"
import script from "./HomePersonalProjects.vue?vue&type=script&lang=js"
export * from "./HomePersonalProjects.vue?vue&type=script&lang=js"

import "./HomePersonalProjects.vue?vue&type=style&index=0&id=1f2aa805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2aa805"]])

export default __exports__